












































import {Component, Vue} from "vue-property-decorator";
import Workspaces from "@/state/Workspaces";
import {namespace} from "vuex-class";
import PayrollFileDTO from "@/dto/payroll/PayrollFileDTO";
import PayrollService from "@/services/payroll/PayrollService";
import PayrollFileCategories from "@/constants/PayrollFileCategories";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import PayrollDocumentActionModal from "@/components/util/DocumentActionModal.vue";

const AppModule = namespace("App");

@Component
export default class GeneralPayrollDetailList extends Vue{

	private workspace = Workspaces.getCurrent;

	@AppModule.Action
	private startLoading!: () => void

	@AppModule.Action
	private stopLoading!: () => void

	private message = "";

	private successful = true;

	public forms: Array<PayrollFileDTO> = [];


	onDocumentClick(document: PayrollFileDTO) {
		if (Workspaces.isUserSublimeEmployee) {
			this.showActions(document);
		} else {
			Vue.prototype.$docUtils.download(document.file.id);
		}
	}

	showActions(document: PayrollFileDTO) {
		this.$modal.show(
			PayrollDocumentActionModal,
			{
				onDelete: () => this.deleteDocument(document),
				onDownload: () => Vue.prototype.$docUtils.download(document.file.id)
			},
			{width: "50%", height: "auto"}
		);
	}

	deleteDocument(document: PayrollFileDTO) {
		this.message = "";
		this.startLoading();
		PayrollService.deleteDocument(document.id, 'PAYROLL_FILE').then(
			response => {
				this.message = "Deleted";
				this.successful = true;
				this.stopLoading();
				this.created();
			},
			error => {
				this.successful = false;
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
				this.stopLoading();
			}
		);
	}

	public created(): void {
		PayrollService.getPayrollFiles(PayrollFileCategories.GENERAL_DETAILS, null, this.workspace.id, null).then(
			(response) => {
				this.successful = true;
				this.forms = response.data;
			},
			(error) => {
				this.successful = false;
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
			}
		)
	}
}
